import React from 'react'
import { Stack, Center, Text, Button, Grid, Group, Image, Anchor, Box } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import errorImg from '@/assets/img/error.png'
import { ReactComponent as IcRefresh } from '@/assets/icon/ic_refresh.svg'
import etfStyles from '@/components/etfs/ETFResultHeader.module.css'

const Error404 = () => {
  const navigate = useNavigate()

  const handleBrowseETFs = () => {
    navigate('/screener')
  }

  return (
    <Center>
      <Grid align="center" gutter="md" maw={800} mt="md">
        <Grid.Col span={{ base: 12, md: 8 }}>
          <Stack>
            <Box className={etfStyles.textWithStyleUnderScore}>
              <Text size="3xl" fw={700} lh={'56px'}>
                <Text span c="blue.3" inherit>
                  Oops!
                </Text>{' '}
                That page seems to have traded places.
              </Text>
            </Box>

            <Text c="grey.7" size="mdlg" mb="md">
              We couldn't find the page you're looking for. It may have been moved or no longer exists.
            </Text>

            <Group gap="sm">
              <Button onClick={handleBrowseETFs}>
                <Group gap="3xs">Browse ETFs</Group>
              </Button>
              <Text c="grey.7">
                or visit our{' '}
                <Anchor href="/assistance/contact" c="grey.8" fw={600} td="underline">
                  Help center
                </Anchor>
              </Text>
            </Group>
          </Stack>
        </Grid.Col>
        <Grid.Col span={4} display={{ base: 'none', md: 'block' }}>
          <Image src={errorImg} alt="Error illustration" width={200} height="auto" />
        </Grid.Col>
      </Grid>
    </Center>
  )
}

export default Error404
